import Vue from 'vue'
import Vuex from 'vuex'

// Modules
// import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import user from './user'
import ticket from './ticket'
import task from './task'
import request from './request'
import roomReservation from "./room-reservation";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    // 'app-ecommerce': ecommerceStoreModule,
    user,
    ticket,
    task,
    request,
    roomReservation
  },
  strict: process.env.DEV,
})
